module.exports = __webpack_public_path__ + "img/banner_left.1d866d16.png";